export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Local Moving',
      description: 'Expert local moving services throughout Southern California. Fast, efficient, and affordable moves within Irvine, Indio, Newport Beach, and surrounding areas.',
      featured: true,
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Long Distance Moving',
      description: 'Reliable long-distance moving services across the country. Professional handling and transport of your belongings to any destination nationwide.',
      featured: true,
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Moving',
      description: 'Minimize downtime with our commercial moving services. Office relocations, equipment transport, and business moves handled with precision.',
      featured: false,
    },
    {
      icon: 'ri-box-3-line',
      title: 'Packing Services',
      description: 'Professional packing and unpacking services. We handle your belongings with care using quality materials to ensure safe transport.',
      featured: false,
    },
    {
      icon: 'ri-music-line',
      title: 'Specialty Items',
      description: 'Expert moving for pianos, antiques, fine art, and valuable items. Specialized equipment and trained professionals for delicate pieces.',
      featured: false,
    },
    {
      icon: 'ri-tools-line',
      title: 'Full-Service Moving',
      description: 'Complete moving solutions including loading, unloading, furniture assembly, picture hanging, and TV mounting. We handle everything.',
      featured: false,
    },
  ];

  const featuredServices = services.filter(s => s.featured);
  const regularServices = services.filter(s => !s.featured);

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <div className="inline-block bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Services
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Moving and Packing Services Tailored to Your Needs
          </h2>
          <p className="text-xl text-slate-600">
            From local moves to long-distance relocations, we offer comprehensive moving solutions for residential and commercial clients in Southern California.
          </p>
        </div>

        {/* Featured Services - Large Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          {featuredServices.map((service, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-slate-50 to-orange-50 rounded-3xl p-10 border-2 border-orange-100 hover:border-orange-300 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">{service.title}</h3>
                  <p className="text-slate-600 leading-relaxed mb-6">{service.description}</p>
                  <a 
                    href="#quote-form" 
                    className="inline-flex items-center text-orange-600 font-bold hover:text-orange-700 transition-colors group"
                  >
                    Get Free Quote 
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Regular Services - Staggered Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {regularServices.map((service, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 ${
                index === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-100 rounded-xl mb-6 group-hover:bg-orange-200 transition-colors">
                <i className={`${service.icon} text-3xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm mb-6">{service.description}</p>
              <a 
                href="#quote-form" 
                className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors text-sm"
              >
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-3xl p-12 text-center shadow-xl">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Make Your Move Stress-Free?
          </h3>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Get your free, no-obligation moving estimate today. Our team is ready to help you plan your perfect move.
          </p>
          <a 
            href="#quote-form" 
            className="inline-block bg-white text-orange-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-slate-50 transition-colors shadow-lg whitespace-nowrap"
          >
            Request Free Estimate
          </a>
        </div>
      </div>
    </section>
  );
}